export default {
  unread: 'Unread',
  read: 'read',
  today: 'Today',
  all: 'All',
  send: 'Send',
  inputTipStart: 'Your message has ',
  inputTipEnd: ' characters, it should be less than 600 characters.',
  orderId: 'Order ID ',
  orderNo: 'Order No ',
  paymentTime: 'Payment Time ',
  orderAmount: 'Order Amount ',
  noSldMsg: 'Please select a chat session',

  search: 'Search',
  noData: 'No data yet',
  uploadTips: 'Picture/Video',
  orderLabel: 'Order',
  product: 'Commodity',
  voucher: 'Store Voucher',
  maxSizeErr: 'The maximum video size is 20M, and the maximum image size is 2M',
  cmdEnter: '(Cmd+Enter)',
  ctrlEnter: '(Ctrl+Enter)'
}
